module.exports = __webpack_public_path__ + "static/media/circle1.872ff848.jpg";